import baseFetch from './helpers';
import config from '../config';

export const trackHeroAd = (result, treatment, width, height) =>
  baseFetch(`${config.servicesURL}/backplane/heroad`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ result, treatment, width, height }),
  });

export default trackHeroAd;



// WEBPACK FOOTER //
// ./src/api/heroAd.js